<template>
  <div class="reward-page-container">
    <nav-component :isMobile="isMobile"></nav-component>
    <div class="reward-cloud-header">
      <div class="centering">
        <div class="header-copy">
          <!-- <img src="@/assets/img/reward-cloud.png" alt /> -->
           <h1>Rewards</h1>
          <h2>One Cloud, Millions of Rewards</h2>
          <p>Over 10 million of the world’s coolest rewards are now available for your program. Rewards delivers merchandise to 196 countries plus enables virtual rewards such as event tickets, retail & prepaid gift cards, mobile top-up & online travel.</p>
        </div>
        <img class="header-img" src="@/assets/img/reward-cloud-header.png" alt />
      </div>
    </div>
    <div class="solution-intro">
      <p>Rewards simplifies your program management with a single dashboard that centralizes all activities.</p>
    </div>

    <div class="personalized-storefront">
      <div class="container">
        <div class="copy">
          <h2>Personalized Storefront</h2>
          <p class="charcoal">
            Our member Storefront, personalized by our revolutionary Rewards AI, offers a beautiful, customizable interface that makes searching and redeeming more fun than ever. Using machine learning, the Personalized Storefront suggests rewards that are more personally meaningful for every individual.
          </p>
          <div class="learn-more">
            <button class="learn-more-btn charcoal-btn" @click="$router.push('/contact')">BOOK A DEMO</button>
          </div>
        </div>
        <div class="storefront-logo-container">
          <img class="fade-right in-view-trans" src="@/assets/img/personalized-storefront.png" alt />
        </div>
      </div>
    </div>

    <div class="storefront-api mb-60">
      <div class="container">
        <img class="storefront-img fade-left in-view-trans" src="@/assets/img/storefront.png" alt />
        <div class="copy">
          <h2>Storefront + API</h2>
          <p
            class="charcoal"
          >Our beautiful, customizable storefront interface is designed to make it easy for members to find and choose the rewards they want. Our robust, state-of-the-art technology consolidates millions of reward items, with constant updates to present the latest rewards&nbsp;options.</p>
          <div class="learn-more">
            <button class="learn-more-btn charcoal-btn" @click="$router.push('/contact')">BOOK A DEMO</button>
          </div>
        </div>
      </div>
    </div>

    <div class="storefront-api">
      <div class="container">
        
        <div class="copy">
          <h2>Custom Branded Storefronts</h2>
          <p class="charcoal">We can showcase your products and offers with beautifully designed custom branded storefronts. These unique pages feature your recognizable brand style and an innovative gallery that makes it easy to browse and buy from your curated selection of products, offers and&nbsp;experiences.</p>
          <div class="learn-more">
            <button class="learn-more-btn charcoal-btn" @click="$router.push('/contact')">BOOK A DEMO</button>
          </div>
        </div>
        <img class="storefront-img fade-left in-view-trans" src="@/assets/img/custom-storefronts-2.png" alt />
      </div>
    </div>

    <div class="innovative-body">
      <h2>Rewards Platform Features</h2>
      <div class="innovative-icons-container">
        <div class="innovative-icon with-transition-delay simple-fade">
          <div class="icon-holder one">
            <img src="@/assets/img/innovation7.png" alt />
          </div>
          <p class="small">Create customized client galleries & catalogues</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder two">
            <img src="@/assets/img/reward2.png" alt />
          </div>
          <p class="small">Reward data refreshes daily across all categories</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder three">
            <img src="@/assets/img/innovation4.png" alt />
          </div>
          <p class="small">Full order tracking and reporting</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder four">
            <img src="@/assets/img/merch.png" alt />
          </div>
          <p class="small">Automated daily merchandise and travel ‘Specials’</p>
        </div>
        <div class="innovative-icon with-transition-delay simple-fade">
          <div class="icon-holder five">
            <img src="@/assets/img/reward3.png" alt />
          </div>
          <p
            class="small"
          >98% of all items are delivered within 2-3 business days within the US</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder six">
            <img src="@/assets/img/innovation8.png" alt />
          </div>
          <p
            class="small"
          >Automated global currency conversions to ensure financial integrity</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder seven">
            <img src="@/assets/img/innovation1.png" alt />
          </div>
          <p class="small">Global tax compliance and reporting</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder eight">
            <img src="@/assets/img/innovation6.png" alt />
          </div>
          <p class="small">GRS Point Bank tracks all member point balances</p>
        </div>
        <div class="innovative-icon with-transition-delay simple-fade">
          <div class="icon-holder nine">
            <img src="@/assets/img/bill.png" alt />
          </div>
          <p
            class="small"
          >Integrated with PayPal &amp; Apple Pay to enable members to securely top-up their points</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder ten">
            <img src="@/assets/img/wand.png" alt />
          </div>
          <p
            class="small"
          >Companies can customize the look and feel of their reward galleries by client</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder eleven">
            <img src="@/assets/img/innovation5.png" alt />
          </div>
          <p class="small">Real-time reporting and order tracking</p>
        </div>
        <div class="innovative-icon simple-fade">
          <div class="icon-holder twelve">
            <img src="@/assets/img/innovation2.png" alt />
          </div>
          <p
            class="small"
          >24/7 global Tier 2 support team connected via an integrated ticketing system</p>
        </div>
      </div>
    </div>

    <div class="grs-translates">
      <div class="main-translate-container">
        <h2 class="translate-header">Rewards are transforming engagement in every industry</h2>
        <div class="translate-row">
          <div class="copy-block left">
            <h2>Financial Institutions</h2>
            <p
              class="charcoal"
            >Rewards is helping financial services organizations transform their interactions with their customers and employees. We help banks and insurance companies reward their loyal customers, boost employee engagement, and power up customer prospecting programs.</p>
            <div class="learn-more">
              <!-- <button class="learn-more-btn">LEARN MORE</button> -->
            </div>
          </div>
          <div class="img-container">
            <img src="@/assets/img/translate1.jpg" alt />
          </div>
        </div>
        <div class="translate-row reverse">
          <div class="img-container">
            <img src="@/assets/img/translate2.jpg" alt />
          </div>
          <div class="copy-block right">
            <h2>Health & Wellness</h2>
            <p
              class="charcoal"
            >Wearable technology and activity tracking software is revolutionizing consumer health and wellness. We’re at the forefront of helping companies reward their members for living an active lifestyle, with a wide range of wellness-focussed rewards and configurable programs that inspire activity.</p>
            <div class="learn-more">
              <!-- <button class="learn-more-btn">LEARN MORE</button> -->
            </div>
          </div>
        </div>
        <div class="translate-row">
          <div class="copy-block left">
            <h2>Travel & Hospitality</h2>
            <p
              class="charcoal"
            >With more than 80% of airline passengers flying only twice a year and earning less than 5,000 mileage points, airlines have few low-value options to reward these customers, and accumulate a complex ‘point debt’. With Rewards Cloud, we can help airlines and hospitality companies minimize that liability by offering their members thousands of unique and attractive redemption options at lower point values.</p>
            <div class="learn-more">
              <!-- <button class="learn-more-btn">LEARN MORE</button> -->
            </div>
          </div>
          <div class="img-container">
            <img src="@/assets/img/translate3.jpg" alt />
          </div>
        </div>
        <div class="translate-row reverse">
          <div class="img-container">
            <img src="@/assets/img/translate4.jpg" alt />
          </div>
          <div class="copy-block right">
            <h2>Retail</h2>
            <p
              class="charcoal"
            >We empower retail businesses by providing a robust reward solution for their employees and for their consumers. Using rewards to increase customer loyalty and employee engagement plays a big part in the retail industry, and our focus is on driving more traffic to your business. Earning points for shopping at a retailer increases brand loyalty and drives traffic.</p>
            <div class="learn-more">
              <!-- <button class="learn-more-btn">LEARN MORE</button> -->
            </div>
          </div>
        </div>
        <div class="translate-row">
          <div class="copy-block left">
            <h2>Fundraising</h2>
            <p
              class="charcoal"
            >Thousands of charities around the globe trust GRS to develop fundraising programs to help them fuel growth and expand their services. From schools to community groups, we can help your cause.</p>
            <div class="learn-more">
              <!-- <button class="learn-more-btn">LEARN MORE</button> -->
            </div>
          </div>
          <div class="img-container">
            <img src="@/assets/img/translate5.jpg" alt />
          </div>
        </div>
        <div class="translate-row reverse">
          <div class="img-container">
            <img src="@/assets/img/translate6.jpg" alt />
          </div>
          <div class="copy-block right">
            <h2>Employee Engagement</h2>
            <p
              class="charcoal"
            >How emotionally committed are your employees to your business? If not truly engaged, an employee will not be as productive, curious, passionate and dedicated as you need them to be. Employee engagement is simply the most critical factor to your long term success. Our solutions are designed specifically to ignite employee engagement — helping you attract and retain top tier talent and boost productivity and profitability.</p>
            <div class="learn-more">
              <!-- <button class="learn-more-btn">LEARN MORE</button> -->
            </div>
          </div>
        </div>

        <div class="translate-row">
          <div class="copy-block left">
            <h2>Home Automation</h2>
            <p
              class="charcoal"
            >We may not (yet) have jetpacks, but for millions of people, smart home products are a simple way to bring the future into their home. Affordable and fun, our curated range of cameras, lights, smart speakers, switches, thermostats (and more!) can free your members from worrying about household ‘infrastructure’ and bring the rewards of security, control and comfort to their home.</p>
            <div class="learn-more">
              <!-- <button class="learn-more-btn">LEARN MORE</button> -->
            </div>
          </div>
          <div class="img-container">
            <img src="@/assets/img/translate7.jpg" alt />
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      name: 'reward-cloud',
      isMobile: window.innerWidth < 992
    }
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 992;
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>


/*HEADER/HERO*/
.reward-cloud-header {
  background-color: #9BDFFF;
  width: 100%;
  padding: 100px 0 30px;
}

.reward-cloud-header .centering {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}
.reward-cloud-header .header-copy { padding-top: 40px; }

.reward-cloud-header .header-copy h1 {
  margin: 10px 0;
  color: #005CAB;
  font-size: 36px;
  font-weight: 400;
  line-height: 52px;
}

.header-copy h2 {
  font-size: 48px;
  font-weight: 700;
  margin: 10px 0;
  color: #343333;
}

.header-copy p {
  width: 90%;
  color: #343333;
}
.reward-cloud-header .header-img {
  width: 40%;
  height: auto;
  align-self: center;
}

/*MAIN PAGE BODY SECTION*/
.reward-page-container .solution-intro {
  width: 100% !important;
  margin: 0 auto;
  text-align: center;
  padding: 50px 80px;
  background-color: #00A4FF;
  box-sizing: border-box;
}
.reward-page-container .solution-intro p {
  color: #FFF;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}

.personalized-storefront { background-color: #fff; }
.storefront-api.mb-60 { background-color: #F7F4F2; }
.personalized-storefront .container {
  padding: 40px 0;
  width: 80%;
  max-width: 1200px;
}
.personalized-storefront .copy { width: 40%; }
.personalized-storefront .copy h2,
.storefront-api .copy h2 {
  color: #343333;
  font-size: 32px;
  font-weight: 700;
  line-height: 52px;
}
.personalized-storefront .copy p,
.storefront-api .copy p {
  color: #343333;
  font-size: 18px;
  font-weight: 300;
  line-height: 24px;
}
.personalized-storefront .container p { width: 100%; }
.storefront-logo-container {
  width: 60%;
  display: flex;
  justify-content: flex-end;
}
.storefront-logo-container img {
  width: 90%;
  -webkit-filter: drop-shadow(0px 3px 9px #d2d2d2);
  filter: drop-shadow(0px 3px 9px #d2d2d2);
}

.innovative-body {
  background-color: #eee;
  padding: 60px 0;
  text-align: center;
}

.innovative-icons-container {
  margin: 0 auto;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center; */
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  place-items: center;
  align-items: start;
  width: 80%;
}
/* .innovative-icons-container .row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  width: 60%;
  margin-bottom: 30px;
} */
.innovative-icons-container p.small {
  margin: 0 0 10px 0;
  text-align: center;
  color: #343333;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}

.innovative-icon { max-width: 200px; }

.icon-holder {
  width: 20px;
  height: 20px;
  padding: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 15px;
}
.icon-holder img {
  width: 60px !important;
  position: absolute;
}

.icon-holder.one { background-color: #00A4FF; }
.icon-holder.two { background-color: #00A561; }
.icon-holder.three { background-color: #F26533; }
.icon-holder.four { background-color: #C7116B; }
.icon-holder.five { background-color: #A817A3; }
.icon-holder.six { background-color: #FAC1AD; }
.icon-holder.seven { background-color: #E388B5; }
.icon-holder.eight { background-color: #6ECBF9; }
.icon-holder.nine { background-color: #99DBC0; }
.icon-holder.ten { background-color: #0079BC; }
.icon-holder.eleven { background-color: #00A561; }
.icon-holder.twelve { background-color: #D48BD1; }


.storefront-api {
  height: 580px;
  background-color: #fff;
}

.storefront-api.mb-60 { margin-bottom: 60px; }
.container {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.container h2 { margin-bottom: 20px; }
.container p {
  width: 70%;
  margin-bottom: 40px;
}

.storefront-img {
  height: 680px;
  position: relative;
  top: -40px;
}

.storefront-api .copy {
  position: relative;
  top: -50px;
  left: 40px;
}

.salesforce-intg { background-color: #eee; }
.salesforce-intg .container {
  width: 80%;
  max-width: 1200px;
  padding: 80px 0;
}


.main-translate-container { padding: 60px 0; }
.main-translate-container h2 {
  color: #343333;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  line-height: 52px;
}

.grs-translates { background-color: #fff; }

.translate-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto 40px;
}
.translate-row .img-container img { max-width: 650px; }
.translate-row .copy-block {
  background-color: #fff;
  border-bottom: 10px solid #00A4FF;
  padding: 40px;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 10px 40px;
}
.translate-row .copy-block.left { left: 80px; }
.translate-row .copy-block.right { right: 80px; }
.translate-row .copy-block h2 {
  text-align: left;
  margin-bottom: 20px;
}
@media screen and (min-width: 1020px) and (max-width: 1150px) {
  .container p { width: 95%; }
}
@media (max-width: 992px) {
  .reward-cloud-header img.header-img { display: none; }
  .reward-cloud-header .header-copy { padding-top: 0; }
  .reward-cloud-header .header-copy h1 { font-size: 42px; }

  .storefront-logo-container img { width: 100%; }

  .solution-intro {
    width: 90% !important;
    padding: 50px 0;
  }

  .innovative-body { padding-bottom: 10px; }

  /* .innovative-icons-container .row {
    flex-wrap: wrap;
    width: 100%;
  } */

  .innovative-icons-container { grid-template-columns: 1fr 1fr 1fr; }

  .innovative-icons-container .icon-holder { padding: 30px; }

  .icon-holder img { width: 40px !important; }

  .storefront-api {
    height: auto;
    padding-bottom: 80px;
  }

  .personalized-storefront .copy {
    width: 90%;
    text-align: center;
  }
  .personalized-storefront .container { padding-top: 60px; }
  .storefront-logo-container { width: 90%; }
  .personalized-storefront .container,
  .storefront-api .container {
    flex-direction: column;
    width: 100%;
    height: auto;
  }
  .storefront-api .copy {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: -20px;
    left: 0;
  }
  .storefront-img {
    width: 90%;
    height: auto;
  }
  .salesforce-intg .container {
    flex-direction: column;
    align-items: center;
  }
  .salesforce-intg .copy { text-align: center; }
  .salesforce-intg .copy p { width: 100%; }
  .salesforce-intg .container .salesforce-logo-container,
  .storefront-logo-container { margin-top: 60px; }

  .translate-header {
    width: 90%;
    margin: 0 auto;
  }
  .grs-translates .translate-row { flex-direction: column; }
  .grs-translates .translate-row.reverse { flex-direction: column-reverse; }
  .grs-translates .translate-row .copy-block {
    width: 90%;
    margin: 0 auto 40px;
    box-sizing: border-box;
  }
  .grs-translates .translate-row .copy-block.left { left: 0; }
  .grs-translates .translate-row .copy-block.right { right: 0; }

  .translate-row .img-container img {
    width: 100%;
    margin: 0 auto 40px;
  }
}

@-moz-document url-prefix() {
  .reward-page-container .reward-cloud-header .header-img {
    width: 90%;
  }
}
</style>
